import React, { useRef, useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import { TooltipEditorModes, TooltipsType } from 'src/components/ReviewViewer/Tooltips/types';
import { truncStringWithElepsis } from 'src/helpers';

type Props = {
    tooltips: TooltipsType;
    deleteTooltip: (tooltipIndex: number) => void;
    mode: TooltipEditorModes;
};

const DeleteTooltip: React.FC<Props> = ({ tooltips, deleteTooltip, mode }) => {
    const anchorRef = useRef<HTMLButtonElement>(null);

    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Button
                ref={anchorRef}
                variant='contained'
                onClick={() => setIsOpen(true)}
                disabled={
                    mode === TooltipEditorModes.AddTooltipCoords ||
                    mode === TooltipEditorModes.AddTooltipSizes ||
                    !tooltips.length
                }
            >
                Удалить подсказку
            </Button>
            {!!tooltips.length && (
                <Menu
                    id='basic-menu'
                    anchorEl={anchorRef.current}
                    open={isOpen}
                    onClose={() => setIsOpen(false)}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    {tooltips.map(({ text }, index) => (
                        <MenuItem key={text}>
                            {truncStringWithElepsis(text, 15)}
                            &nbsp;
                            <DeleteIcon onClick={() => deleteTooltip(index)} />
                        </MenuItem>
                    ))}
                </Menu>
            )}
        </>
    );
};

export { DeleteTooltip };
